
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.469 9.865l3.437 3.437 9.531-9.531L22 5.333 10.906 16.427l-5-5L7.47 9.865zM19.76 19.76v-8.854H22v8.854c0 .59-.226 1.112-.677 1.563-.451.451-.972.677-1.563.677H4.24c-.59 0-1.112-.226-1.563-.677C2.226 20.872 2 20.35 2 19.76V4.24c0-.59.226-1.112.677-1.563C3.128 2.226 3.65 2 4.24 2h11.093v2.24H4.24v15.52h15.52z"}})])
          )
        }
      }
    